import { Button } from '@/components/ui/button.jsx';

// Renders the add-pilot contract's 409 conflict descriptors with the
// resolution choices the backend accepts (Phase 4.7.1, extracted from
// AddPilotCard for the paper-PHF holding strip). name_match_no_email: link
// the email to the existing emailless Contact (recommended) or add a separate
// person. email_in_use: every person has his own email (David 2026-10-22), so
// cancel to fix the email, or add a separate person made without it (no email
// yet: no mail goes to the other person's address; David's needs-own-email
// item asks for his own).
// public_intake_claim (docs/security/PUBLIC-INTAKE-PHF-CONTACT.md): a public
// applicant typed an existing client's email. The only answers are "same
// person" (link to that record) or cancel and dismiss the form; there is no
// separate-person button here, because the claim door refuses that answer.
export default function ConflictPanel({ conflict, busy, onResolve, onCancel }) {
  const isNameMatch = conflict.conflict === 'name_match_no_email';
  const isClaim = conflict.conflict === 'public_intake_claim';
  const existingId = conflict.existing_contact?.id;
  return (
    <div className="space-y-4">
      <div className="rounded-card border border-warning/40 bg-warning/5 px-3 py-2.5 text-sm text-text">
        {conflict.message}
      </div>
      <div className="flex flex-col gap-2">
        {isNameMatch && existingId && (
          <Button type="button" disabled={busy}
            onClick={() => onResolve({ action: 'link_existing', target_contact_id: existingId })}>
            {busy ? 'Linking…' : 'Link to existing contact (recommended)'}
          </Button>
        )}
        {isClaim && existingId && (
          <Button type="button" variant="ghost" disabled={busy}
            onClick={() => onResolve({ action: 'link_existing', target_contact_id: existingId })}>
            {busy ? 'Linking…' : 'Same person: write these answers to their record'}
          </Button>
        )}
        {!isClaim && (
          <Button type="button" variant={isNameMatch ? 'ghost' : 'default'} disabled={busy}
            onClick={() => onResolve({ action: 'shared_email' })}>
            {busy ? 'Adding…' : (isNameMatch ? 'Add as a separate person' : 'Add as a separate person (no email yet)')}
          </Button>
        )}
        <Button type="button" variant="ghost" disabled={busy} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
